module.exports = require('./helpers/bundle-url').getBundleURL('UckoE') + "Shopping cart.d2b89455.png" + "?" + Date.now();